import { get, post, put, del } from "./ApiService";
const must = (c, m) => { if (!c) throw new Error(m); };

export const getBugsByProject = (projectId) =>
  get("/bugs", { project_id: projectId, source: "web" }).then((r) => r.bugs);

export const addBug = (data = {}) =>
  post("/bugs", { ...data, source: "web" });

export const updateBug = async (id, data = {}) => {
  must(id, "bug id gerekli");

  const project = data.project_id || data.uniq_id || data.uniq;
  must(project, "project_id/uniq_id gerekli");

  const title = (data.title ?? "").toString().trim();
  must(title.length > 0, "title gerekli");

  const versionName = (data.version_name ?? data.version ?? "").toString().trim();
  must(versionName.length > 0, "version_name gerekli");

  const userId = data.user_id ?? data.userId ?? data.updated_by ?? data.created_by;
  const externalUrl = data.external_url ?? data.externalUrl;

  const payload = {
    id,
    bug_id: id,

    project_id: data.project_id ?? project,
    uniq_id: data.uniq_id ?? project,
    uniq: data.uniq ?? project,

    title,
    bug_title: title,
    description: (data.description ?? "").toString(),
    bug_description: (data.description ?? "").toString(),
    file_url: (data.file_url ?? "").toString(),

    version_name: versionName,
    version: versionName,
    ...(data.version_id ? { version_id: data.version_id } : {}),
    ...(userId ? { user_id: userId } : {}),
    ...(externalUrl ? { external_url: externalUrl } : {}),

    source: "web",
  };

  if (window.__DEBUG_API__) {
    console.log("[updateBug payload]", payload);
  }

  return put("/bugs", payload);
};

export const updateBugStatus = (id, done, projectId, userId) => {
  must(id, "bug id gerekli");
  const base = {
    id,
    bug_id: id,
    is_completed: done ? 1 : 0,
    source: "web",
    ...(userId ? { user_id: userId } : {}),
  };
  const withProj = projectId
    ? { ...base, project_id: projectId, uniq_id: projectId, uniq: projectId }
    : base;
  return put("/bugs", withProj);
};

export const deleteBug = (id, projectId) => {
  must(id, "bug id gerekli");
  const base = { id, bug_id: id, source: "web" };
  const withProj = projectId
    ? { ...base, project_id: projectId, uniq_id: projectId, uniq: projectId }
    : base;
  return del("/bugs", withProj);
};

export const getVersions = (projectId) =>
  get("/versions.php", { uniq: projectId, source: "web" });

export const renameVersion = (id, newName) =>
  put("/versions.php", { id, new_name: newName });

export const addVersion = (projectId, name) =>
  post("/versions.php", { uniq_id: projectId, version_name: name, source: "web" });

export const setVersionDeadline = (versionId, isoDateString) =>
  put("/versions.php", { id: versionId, deadline: isoDateString });

export const updateVersion = ({ id, deadline, close = false, newName } = {}) => {
  must(id, "version id gerekli");
  const payload = {
    id,
    ...(deadline !== undefined ? { deadline } : {}),
    ...(close ? { close: true } : {}),
    ...(newName ? { new_name: newName } : {}),
    source: "web",
  };
  return put("/versions.php", payload);
};

export const getProjectUsers = (projectId) =>
  get("/project_users", { project_id: projectId }).then((r) => r.users);

export const inviteUserToProject = (projectId, email) =>
  post("/invites", { project_id: projectId, email });

export const leaveProject = (projectId, userId, token) =>
  del("/project_users", { project_id: projectId, user_id: userId, token });

export const leaveProjectByProjectsEndpoint = (projectId, userId, token) =>
  del("/projects", { project_id: projectId, user_id: userId, token });

export const deleteProject = (projectId, userId, token) =>
  del("/projects", { project_id: projectId, user_id: userId, token });

export const getBugDetails = (bugId) =>
  get("/bug_detail", { bug_id: bugId, source: "web" });
